import { render, staticRenderFns } from "./sousuo.vue?vue&type=template&id=1109f8cd&scoped=true"
var script = {}
import style0 from "./sousuo.vue?vue&type=style&index=0&id=1109f8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1109f8cd",
  null
  
)

export default component.exports